const LevelSettingsModeEnum = {
    MAIN: 0,
    LEVEL_GOAL: 1,
    LEVEL_VIEW: 2
};

export default LevelSettingsModeEnum;